var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.927734 0.840882C0.927734 0.554906 1.159 0.323639 1.44498 0.323639H22.1695C22.4555 0.323639 22.6868 0.554906 22.6868 0.840882V21.5654C22.6868 21.8514 22.4555 22.0827 22.1695 22.0827H1.44498C1.159 22.0827 0.927734 21.8514 0.927734 21.5654V0.840882ZM1.96471 1.36061V21.0457H21.6498V1.36061H1.96471Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.07324 4.98682C5.07324 4.70084 5.30451 4.46957 5.59049 4.46957H18.0242C18.3102 4.46957 18.5415 4.70084 18.5415 4.98682V7.57801H17.507V5.50406H6.10773V7.57801H5.07324V4.98682Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2899 16.9017V4.98517H12.3244V16.9017H14.9156V17.9361H8.69873V16.9017H11.2899Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/Text.0bd5374c1fcc53cc9e31398231308a8e.svg";
export { ForwardRef as ReactComponent };